import { useCamerasListState } from "@src/features/cameras/hooks/useCamerasListState";
import { resolveTenantFeatures, type TenantFeatures } from "./tenant-features";

/**
 * What the current tenant's assets are hired for, read off the camera list the
 * app already loads and shares rather than a request of its own. React Query
 * serves the cached list straight away in the common case.
 *
 * The decision itself lives in {@link resolveTenantFeatures} so it can be unit
 * tested without the React Native module graph.
 */
export function useTenantFeatures(): TenantFeatures {
  return resolveTenantFeatures(useCamerasListState());
}
